<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Список заявок и&nbsp;их данные</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="spisok-zayavok"
            class="typography__headline2"
          >
            Список заявок
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Заявки&raquo;. Если есть новые заявки&nbsp;&mdash;
              на&nbsp;этом разделе будет уведомление с&nbsp;их&nbsp;числом.
            </p>

            <p>Сверху справа можно добавить новую заявку.</p>

            <p>
              В&nbsp;списке можно быстро поменять статус заявки, если она уже была обработана. Также там есть важная
              информация, возможность открыть чат с&nbsp;клиентом, если он&nbsp;уже есть, быстро перейти
              к&nbsp;редактированию или удалению.
            </p>

            <p>По&nbsp;нажатию в&nbsp;свободное от&nbsp;активных элементов место перейдем к&nbsp;странице заявки.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-zayavok-i-ikh-dannye-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>Над списком есть сортировка, фильтры и&nbsp;поисковая строка для быстрого поиска нужной заявки.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-zayavok-i-ikh-dannye-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="stranica-zayavki"
            class="typography__headline2"
          >
            Страница заявки
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              На&nbsp;открывшейся странице заявки сверху можно увидеть её&nbsp;номер. Под названием быстрый доступ
              к&nbsp;редактированию или удалению.
            </p>

            <p>Ниже можно быстро сменить статус заявки и&nbsp;посмотреть всю нужную информацию.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-zayavok-i-ikh-dannye-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С добавлением заявок и их просмотром разобрались. Самое время перейти к изучению
            <BaseLink
              class="ui-link-secondary"
              to="/faq/categories/zakazy-s-tovarami"
              >товаров и их заказу</BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Заявки на&nbsp;услуги",
    url: "/faq/categories/zayavki-na-uslugi",
  },
  {
    name: "Список заявок и&nbsp;их данные",
  },
];

const menu = [
  {
    name: "Список&nbsp;заявок",
    url: "spisok-zayavok",
  },
  {
    name: "Страница&nbsp;заявки",
    url: "stranica-zayavki",
  },
];

const relatedArticles = [
  {
    name: "Что такое заявки на услуги",
    slug: "chto-takoye-zayavki-na-uslugi",
  },
  {
    name: "Добавление и&nbsp;редактирование заявки",
    slug: "dobavleniye-i-redaktirovaniye-zayavki",
  },
];

useSeoMeta({
  title: "Список заявок и их данные",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
